"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ArrayStrategy;
(function (ArrayStrategy) {
    ArrayStrategy["PUSH"] = "PUSH";
    ArrayStrategy["REPLACE"] = "REPLACE";
})(ArrayStrategy || (ArrayStrategy = {}));
exports.default = ArrayStrategy;
//# sourceMappingURL=ArrayStrategy.js.map